import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import execute from './get';
import { useQuery as useReactQuery, useSuspenseQuery as useSuspenseReactQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
/**
 * Returns a query key that should be used with useQuery.
 *
 * Disclaimer: Do not use this with useInfiniteQuery, prefer getInfiniteQueryKey.
 */ export function getQueryKey(options) {
    return [
        "/retailers-pos-api/pos-locations",
        options
    ];
}
/**
 * Returns a query key that should be used with useInfiniteQuery.
 */ export function getInfiniteQueryKey(options) {
    return [
        'infinite'
    ].concat(_to_consumable_array(getQueryKey(options)));
}
export function getQueryFn(options) {
    return function(param) {
        var signal = param.signal;
        var optionsWithSignal = _object_spread_props(_object_spread({}, options), {
            signal: signal
        });
        return execute(optionsWithSignal);
    };
}
export function useQuery(reactQueryOptions, options) {
    return useReactQuery(_object_spread({
        queryKey: getQueryKey(options),
        queryFn: getQueryFn(options)
    }, reactQueryOptions));
}
export function useSuspenseQuery(suspenseReactQueryOptions, options) {
    return useSuspenseReactQuery(_object_spread({
        queryKey: getQueryKey(options),
        queryFn: getQueryFn(options)
    }, suspenseReactQueryOptions));
}
export function usePrefetchQuery() {
    var queryClient = useQueryClient();
    var prefetch = useCallback(function(fetchQueryOptions, options) {
        return queryClient.prefetchQuery(_object_spread({
            queryKey: getQueryKey(options),
            queryFn: getQueryFn(options)
        }, fetchQueryOptions));
    }, [
        queryClient
    ]);
    return prefetch;
}
/**
 * Returns a function that invalidates the query for this endpoint.
 * After being invalidated the query will be refetched on the next useQuery call.
 */ export function useInvalidateQuery() {
    var queryClient = useQueryClient();
    var invalidate = useCallback(function(options, invalidateQueryFilters, invalidateOptions) {
        return queryClient.invalidateQueries(_object_spread({
            queryKey: getQueryKey(options)
        }, invalidateQueryFilters), invalidateOptions);
    }, [
        queryClient
    ]);
    return invalidate;
}
/**
 * Returns a function that invalidates the infinite query for this endpoint.
 * After being invalidated the query will be refetched on the next useInfiniteQuery call.
 */ export function useInvalidateInfiniteQuery() {
    var queryClient = useQueryClient();
    var invalidate = useCallback(function(options, invalidateQueryFilters, invalidateOptions) {
        return queryClient.invalidateQueries(_object_spread({
            queryKey: getInfiniteQueryKey(options)
        }, invalidateQueryFilters), invalidateOptions);
    }, [
        queryClient
    ]);
    return invalidate;
}
